import React from "react";
import FormControl from '@mui/material/FormControl';
import { Box, Typography, TextField } from "@mui/material";
import FormHelperText from '@mui/material/FormHelperText';
import './ChannelDetail.css';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import Select from '@mui/material/Select';


export const ChannelDetailForm = (props) => {
  const role = localStorage.getItem("role");

  const { channelName, setChannelName, setUser, user, users } = props;
  return (
    <Box className="Box23" >
      {role == 1 ? (
        <FormControl sx={{ width: "49%" }}>
          <InputLabel id="demo-simple-select-label">User</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={user.value}
            label="User"
            onChange={(e) => setUser({ ...user, value: e.target.value })}
            sx={{ textTransform: "capitalize" }}
          >
            {users?.map(item => (
              <MenuItem key={item?.id} sx={{ textTransform: "capitalize" }} value={item?.id}>{item.name}</MenuItem>
            ))}


          </Select>
        </FormControl>
      ) : null}

      <FormControl variant="standard" sx={{ display: "flex", flexDirection: "column", gap: "10px", width: role === "1" ? "49%" : "100%" }}>
        <TextField className="TextField" id="outlined-basic" label="Channel Name" variant="outlined" value={channelName.value} InputLabelProps={{ shrink: channelName ? true : false }} onChange={e => setChannelName({ ...channelName, value: e.target.value })} />
        <FormHelperText id="component-error-text" sx={{ color: "red" }}>{channelName.error}</FormHelperText>
      </FormControl>
    </Box>
  );
};